import {
  HttpClient,
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError, of} from 'rxjs';
// import 'rxjs/add/observable/empty'
import { SharedService } from './services/shared.service';
import { UserIdleService } from 'angular-user-idle';
import { catchError, concatMap, delay, filter, retryWhen, tap } from 'rxjs/operators';

@Injectable()
export class MyHttpLogInterceptor implements HttpInterceptor {
  private pocessed: boolean = true; // to indicate Special header data recieved
  private request = new Subject<any>(); // Subject stream to indicate custom responses
  private requests: HttpRequest<any>[] = []; // to store http requests

  constructor(private userIdle: UserIdleService, private sharedService: SharedService) { }

  requestSetter(response: any) { this.request.next(response) } // set subject stream data
  requestGetter(): Observable<any> { return this.request.asObservable() } // listen to Stream changes and return steeam data

  // remove previous requests from queue/ Array
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
      this.sharedService.setLoading(this.requests.length > 0);
    }
  }

  // Default Interceptor Functionality
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if(!(req && req.url && req.url.indexOf('/token') >= 0)) {
      this.userIdle.resetTimer();
    }
    
    
    return Observable.create(observer => {
      if (this.pocessed) {
        // Stop Processing until get the token result
        if(req && req.url && req.url.indexOf('/token') >= 0 && !location.href.split('/').includes('login')) {
          this.pocessed = false
        }
        
        let authReq, skipRetry, authorization;
        this.headerReqConfig(req).then(res => {
          authReq = res['authReq'];
          skipRetry = res['skipRetry'];
          authorization = res['authorization'];
        }).then(() =>{
          this.apiCall(req, next, authReq, skipRetry, authorization, observer)   
        })
    } else {
        this.requests.push(req);
        this.requestGetter().subscribe(res => {
          const i = this.requests.indexOf(req);
          if (i >= 0) {
            this.requests.splice(i, 1);
            let authReq, skipRetry, authorization;
            this.headerReqConfig(req).then(res => {
              authReq = res['authReq'];
              skipRetry = res['skipRetry'];
              authorization = res['authorization'];
            }).then(() =>{
              this.apiCall(req, next, authReq, skipRetry, authorization, observer)   
            })
          }
        });
      }
    });
  }
  headerReqConfig(req) {
    let contentType = 'application/json',
      authorization = sessionStorage.getItem('access_token') ? 'Bearer ' + sessionStorage.getItem('access_token') : '',
      txnUser = sessionStorage.getItem('loginuser') || '';

    const facilityType = sessionStorage.getItem('facilityType') || '',
      cdssType = sessionStorage.getItem('cdssType') || '',
      facilityTypeId = sessionStorage.getItem('facilityTypeId') || '';
    let skipRetry = false;

    if (req.headers['lazyUpdate']) {
      req.headers['lazyUpdate'].forEach((h) => {
        if (h.name === 'Content-Type') {
          contentType = h.value;
        }
        if (h.name === 'Authorization') {
          authorization = h.value;
        }
        if (h.name === 'txnUser') {
          txnUser = h.value;
        }
        if (h.name === 'skipRetry') {
          skipRetry = h.value;
        }
      });
    }
    const islocalHost = window.location.hostname === 'localhost';
    const authReq = req.clone({
      url: (islocalHost ? '': '/portal' + req.url),
      headers: req.headers
        .set('txnUser', txnUser)
        .set('Content-Type', contentType)
        .set('Authorization', authorization)
        .set('facilityType', facilityType)
        .set('facilityTypeId', facilityTypeId)
        .set('isCdssFacility', cdssType),
    });
    return new Promise(resolve=>{
      return resolve({authReq, skipRetry, authorization})
    }) 
  }

  apiCall(req, next, authReq, skipRetry, authorization, observer) {
    if (authReq.method === 'GET') {
      if(skipRetry) {
        const subscription = next.handle(authReq).subscribe(event => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
          catchError((err) => {
            if (
              (err &&
                err.status === 401 &&
                err.error &&
                err.error.error &&
                err.error.error.toLowerCase().includes('unauthorized')) ||
             !authorization
           ) {
              sessionStorage.clear();
              this.userIdle.stopWatching();
              window.open(window.location.origin, '_parent');
            } else {
              return throwError(err);
            }
          })
        },
          err => {
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
        // remove request from queue when cancelled
        return () => {
          this.removeRequest(req);
          subscription.unsubscribe();
        };
      } else {
        const subscription = next.handle(authReq).subscribe(event => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
          catchError((err) => {
            if (
              (err &&
                err.status === 401 &&
                err.error &&
                err.error.error &&
                err.error.error.toLowerCase().includes('unauthorized')) ||
              !authorization
            ) {
              sessionStorage.clear();
              this.userIdle.stopWatching();
              window.open(window.location.origin, '_parent');
            } else {
              return throwError(err);
            }
          }),
          retryWhen((errors) =>
            errors.pipe(
              concatMap((error, count) => {
                if (
                  count < 2 &&
                  error instanceof HttpErrorResponse &&
                  (error.status === 400 ||
                    error.status === 404 ||
                    error.status === 502 ||
                    error.status === 503 ||
                    ((authReq.url.indexOf('leftPanel') > -1 || authReq.url.indexOf('initialAssessment') > -1) &&
                      error.message === 'Invalid input individualId !'))
                ) {
                  return of(error.status);
                }
                return throwError(error);
              }),
              delay(1000)
            )
          )
        },
          err => {
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
        // remove request from queue when cancelled
        return () => {
          this.removeRequest(req);
          subscription.unsubscribe();
        };
      }
    } else {
      const subscription = next.handle(authReq).subscribe(event => {
        if (event instanceof HttpResponse) {
          if(authReq && authReq.url && req.url.indexOf('/token') >= 0 && !location.href.split('/').includes('login')) {
            sessionStorage.setItem('access_token', event.body.access_token);
            sessionStorage.setItem('refresh_token', event.body.refresh_token);
            this.pocessed = true;
            this.requestSetter({ key: this.pocessed });
          }
          this.removeRequest(req);
          observer.next(event);
        }
        catchError((err) => {
          if (
            (err &&
              err.status === 401 &&
              err.error &&
              err.error.error &&
              err.error.error.toLowerCase().includes('unauthorized')) ||
           !authorization
         ) {
            sessionStorage.clear();
            this.userIdle.stopWatching();
            window.open(window.location.origin, '_parent');
          } else {
            return throwError(err);
          }
        })
      },
        err => {
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    }
  }

}